import styled from 'styled-components';

export const DivUser = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 16px;
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 1;
  img {
    border-radius: 50%;
    width: 46px;
    border: 2px solid white;
  }
`
